import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  Component,
  inject,
  input,
  InputSignal,
  TemplateRef,
} from '@angular/core';
import { LoadingAnimationComponent } from '../../feedback/loading-animation/loading-animation.component';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';

export type SimpleTableDensity = 'compact' | 'comfortable';

@Component({
  selector: 'aw-simple-table',
  imports: [
    AppendTestIdPipe,
    LoadingAnimationComponent,
    NgClass,
    NgTemplateOutlet,
  ],
  templateUrl: './simple-table.component.html',
})
export class SimpleTableComponent<T> {
  public readonly id: InputSignal<string> = input.required<string>();
  public readonly data: InputSignal<T[] | undefined> = input<T[]>();
  public readonly isLoading: InputSignal<boolean> = input<boolean>(false);
  public readonly showHeader: InputSignal<boolean> = input<boolean>(true);
  public readonly showLastRowBorder: InputSignal<boolean> =
    input<boolean>(false);
  public readonly density: InputSignal<SimpleTableDensity> =
    input<SimpleTableDensity>('comfortable');
  public readonly applyDefaultCellStyles: InputSignal<boolean> =
    input<boolean>(true);
  public readonly header: InputSignal<TemplateRef<unknown>> =
    input.required<TemplateRef<unknown>>();
  public readonly columns: InputSignal<TemplateRef<unknown>> =
    input.required<TemplateRef<unknown>>();
  public readonly trackBy: InputSignal<
    ((dataPoint: T, index: number) => unknown) | undefined
  > = input<((dataPoint: T, index: number) => unknown) | undefined>();
  public readonly isRowVisible: InputSignal<
    ((dataPoint: T) => boolean) | undefined
  > = input<((dataPoint: T) => boolean) | undefined>();
  public readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  protected rowKey(dataPoint: T, index: number): unknown {
    return this.trackBy()?.(dataPoint, index) ?? index;
  }

  protected rowIsVisible(dataPoint: T): boolean {
    return this.isRowVisible()?.(dataPoint) ?? true;
  }
}
